module.exports = __webpack_public_path__ + "static/media/sonar-icon.529bc9e6.png";